import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import 'react-dropdown/style.css';
// import MDInput from "components/MDInput";
import React, { useState, useEffect } from "react";
import { Oval } from 'react-loader-spinner';
import Table from '@mui/material/Table';
// import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Select from 'react-select';
import * as moment from 'moment';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import MDButton from 'components/MDButton';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
// import { jsPDF } from 'jspdf';
// import html2canvas from "html2canvas";
import * as service from '../../services/service';

function SupplierPaymentReport() {
    const [reportDetailsData, setReportDetailsData] = useState([]);
    const [showDetailsReport, setShowDetailsReport] = useState(false);
    const [supplierData, setSupplierData] = useState([]);
    const [supplierId, setSupplierId] = useState('');
    const [purchaseOrderData, setPurchaseOrderData] = useState([]);
    const [purchaseOrderId, setPurchaseOrderId] = useState('');
    const [poFor, setPOFor] = useState('');
    const poForData = [{ label: 'Work', value: 'Work' }, { label: 'Material', value: 'Material' }]
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const selectStyles = { menu: styles => ({ ...styles, zIndex: 999 }) };
    const userDesignation = JSON.parse(sessionStorage.getItem('userData')).designation;
    const getSuppliers = () => {
        fetch(
            service.SUPPLIER_URL,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
            })
            .then(res => res.json())
            .then(result => {
                const data2 = result.map((item) => ({ value: item.supplierId, label: item.supplierName }));
                const all = ({ value: "0", label: "All" });
                data2.unshift(all);
                setSupplierData(data2);
                setSupplierId(all);
            });
    };
    const getPurchaseOrders = (id) => {
        fetch(
            service.GET_PURCHASE_ORDER_BY_TYPE,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    PurchaseOrderFor: poFor.value,
                    SupplierId: id,
                })
            })
            .then(res => res.json())
            .then(result => {
                const data2 = result.map((item) => ({ value: item.purchaseOrderId, label: item.purchaseOrderNo }));
                setPurchaseOrderData(data2);
            });
    };
    function GetReport() {
        const errs = {};
        fetch(
            service.GET_SUPPLIER_PAYMENT_REPORT,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    PurchaseOrderFor: poFor.value,
                    SupplierId: supplierId ? supplierId.value : 0,
                    PurchaseOrderId: purchaseOrderId ? purchaseOrderId.value : 0,
                    FromDate: fromDate ? moment(fromDate).format("MM/DD/YYYY") : null,
                    ToDate: toDate ? moment(toDate).format("MM/DD/YYYY") : null
                })
            })
            .then(res => res.json())
            .then(result => {
                if (result.length === 0) {
                    errs[".invalid"] = 'No Data Found!';
                    setErrors(errs);
                    setShowDetailsReport(false);
                }
                else if (result.length > 0 && result[0].message.messageType === 'Success') {
                    setShowDetailsReport(true);
                    setReportDetailsData(result);
                    errs[".invalid"] = '';
                    setErrors(errs);
                }
                else if (result[0].message.messageType === 'Failed') {
                    errs[".invalid"] = result[0].message.message;
                    setErrors(errs);
                    setShowDetailsReport(false);
                }
                else {
                    errs[".invalid"] = result[0].message.message;
                    setErrors(errs);
                    setShowDetailsReport(false);
                }
            });
    }

    useEffect(() => {
        setLoading(true);
        getSuppliers();
        setLoading(false);
    }, []);

    const poForChangeHandler = (ev) => {
        setPOFor(ev);
        setSupplierId(null);
        setPurchaseOrderId(null);
        setPurchaseOrderData(null);
        setReportDetailsData([]);
    }

    const changeHandler = (ev) => {
        setSupplierId(ev);
        getPurchaseOrders(ev.value);
        setReportDetailsData([]);
    }
    const purchaseOrderchangeHandler = (ev) => {
        setPurchaseOrderId(ev);
        setReportDetailsData([]);
    }

    const validate = () => {
        let isValid = true;
        const errs = {};
        if (!poFor) {
            isValid = false;
            errs[".poFor"] = "Please select for";
        }
        setErrors(errs);
        return isValid;
    }
    const submitHandler = e => {
        setReportDetailsData([]);
        setShowDetailsReport(false);
        e.preventDefault();
        setLoading(true);
        if (validate()) {
            GetReport();
        }
        setLoading(false);
    }

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={6} pb={3}>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        {userDesignation === 'General Manager' || userDesignation === 'Asst Mgr - Accounts'
                            || userDesignation === 'Jr Mgr - Accounts' || userDesignation === 'Manager - Accounts'
                            || userDesignation === 'Sr Mgr - Accounts' || userDesignation === 'MD' 
                            || userDesignation === 'Jr Mgr - Purchase' || userDesignation === 'Manager - Purchase'
                            || userDesignation === 'Sr Mgr - Purchase' ?
                            <Card>
                                <MDBox
                                    mx={2}
                                    mt={-3}
                                    py={3}
                                    px={2}
                                    variant="gradient"
                                    bgColor="info"
                                    borderRadius="lg"
                                    coloredShadow="info"
                                >
                                    <MDTypography variant="h6" color="white">
                                        Supplier Payment Report
                                    </MDTypography>
                                </MDBox>
                                <br />
                                <Table aria-label="simple table">
                                    <TableRow>
                                        <TableCell width="10%" align="right" style={{ fontSize: '12px' }}>
                                            For :
                                        </TableCell>
                                        <TableCell width="25%" align='left' style={{ fontSize: '12px' }}>
                                            <Select
                                                name="poFor"
                                                options={poForData} placeholder="Select For"
                                                value={poFor}
                                                onChange={poForChangeHandler}
                                                isSearchable
                                                styles={selectStyles}
                                            />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".poFor"]}</div>
                                        </TableCell>
                                        <TableCell width="10%" align="right" style={{ fontSize: '12px' }}>
                                            Supplier :
                                        </TableCell>
                                        <TableCell width="25%" align="left" style={{ fontSize: '12px' }}>
                                            <Select
                                                options={supplierData}
                                                name="supplierId"
                                                value={supplierId}
                                                onChange={changeHandler}
                                                placeholder="Select Supplier"
                                                isSearchable
                                                styles={selectStyles}
                                            />
                                        </TableCell>
                                        <TableCell width="10%" align="right" style={{ fontSize: '12px' }}>
                                            Purchase Order :
                                        </TableCell>
                                        <TableCell align="left" style={{ fontSize: '12px' }}>
                                            <Select
                                                options={purchaseOrderData}
                                                name="purchaseOrderId"
                                                value={purchaseOrderId}
                                                onChange={purchaseOrderchangeHandler}
                                                placeholder="Select Purchase Order"
                                                isSearchable
                                                styles={selectStyles}
                                            />
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell align="right" style={{ fontSize: '12px' }}>
                                            From Date :
                                        </TableCell>
                                        <TableCell style={{ fontSize: '12px' }}>
                                            <DatePicker
                                                id="fromDate"
                                                selected={fromDate}
                                                onChange={date => setFromDate(date)}
                                                dateFormat="MM/dd/yyyy"
                                            />
                                        </TableCell>
                                        <TableCell align="right" style={{ fontSize: '12px' }}>
                                            To Date :
                                        </TableCell>
                                        <TableCell style={{ fontSize: '12px' }}>
                                            <DatePicker
                                                id="toDate"
                                                selected={toDate}
                                                onChange={date => setToDate(date)}
                                                dateFormat="MM/dd/yyyy"
                                            />
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell colSpan="6" align="center">
                                            <MDBox mt={4} mb={1} textAlign="center">
                                                {loading ?
                                                    <Oval
                                                        heigth="20"
                                                        width="20"
                                                        color='grey'
                                                        ariaLabel='loading'
                                                    />
                                                    :
                                                    <MDButton color="info" onClick={submitHandler}>
                                                        Show
                                                    </MDButton>
                                                }
                                                {errors ? <div style={{ fontSize: '12px', color: 'red' }}>{errors[".invalid"]}</div> : null}
                                            </MDBox>
                                        </TableCell>
                                    </TableRow>
                                </Table>
                                <Card style={{ alignItems: 'center' }}>
                                    {loading ?
                                        <Oval
                                            heigth="100"
                                            width="100"
                                            color='grey'
                                            ariaLabel='loading'
                                        /> :
                                        <TableContainer component={Paper} style={{ width: '98%', alignSelf: 'center' }}>
                                            <Table id="dvDetailReport">
                                                <TableRow>
                                                    <TableCell colSpan="19" align="center">
                                                        <Table>
                                                            <TableCell align="center" style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                                                For : {poFor.value}
                                                            </TableCell>
                                                            <TableCell align="center" style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                                                Supplier : {supplierId ? supplierId.label : 'All'}
                                                            </TableCell>
                                                            <TableCell align="center" style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                                                Purchase Order No : {purchaseOrderId ? purchaseOrderId.label : 'All'}
                                                            </TableCell>
                                                            <TableCell align="center" style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                                                From Date : {fromDate ? moment(fromDate).format("DD/MM/YYYY") : ''}
                                                            </TableCell>
                                                            <TableCell align="center" style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                                                To Date : {toDate ? moment(toDate).format("DD/MM/YYYY") : ''}
                                                            </TableCell>
                                                        </Table>
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow style={{ backgroundColor: 'lightgrey' }}>
                                                    <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Supplier</TableCell>
                                                    <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Purchase Order No.</TableCell>
                                                    <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Purchase Amount</TableCell>
                                                    <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Bill No.</TableCell>
                                                    <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Payment Date</TableCell>
                                                    <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Paid Amount</TableCell>
                                                    <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Payment Mode</TableCell>
                                                    <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>UTRCode</TableCell>
                                                    <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Bank</TableCell>
                                                    <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Branch</TableCell>
                                                </TableRow>
                                                {reportDetailsData.map((row) => (
                                                    <TableRow
                                                        key={row.paymentId}
                                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                    >
                                                        <TableCell style={{ fontSize: '14px' }}>{row.supplierName}</TableCell>
                                                        <TableCell style={{ fontSize: '14px' }}>{row.purchaseOrderNo}</TableCell>
                                                        <TableCell style={{ fontSize: '14px' }}>{row.purchaseAmount}</TableCell>
                                                        <TableCell style={{ fontSize: '14px' }}>{row.billNo}</TableCell>
                                                        <TableCell style={{ fontSize: '14px' }}>{moment(row.paymentDate).format("DD/MM/YYYY")}</TableCell>
                                                        <TableCell style={{ fontSize: '14px' }}>{row.paidAmount}</TableCell>
                                                        <TableCell style={{ fontSize: '14px' }}>{row.paymentMode}</TableCell>
                                                        <TableCell style={{ fontSize: '14px' }}>{row.utrCode}</TableCell>
                                                        <TableCell style={{ fontSize: '14px' }}>{row.bank}</TableCell>
                                                        <TableCell style={{ fontSize: '14px' }}>{row.branch}</TableCell>
                                                    </TableRow>
                                                ))}
                                            </Table>
                                            <br />
                                            <Table>
                                                <TableRow>
                                                    <TableCell align="center">
                                                        {showDetailsReport ?
                                                            <ReactHTMLTableToExcel table="dvDetailReport" className="info"
                                                                filename="ReportData" sheet="Sheet" buttonText="EXPORT TO EXCEL"
                                                            />
                                                            : null}
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell>{errors[".invalid"]}</TableCell>
                                                </TableRow>
                                            </Table>
                                        </TableContainer>
                                    }
                                </Card>
                            </Card>
                            :
                            <Card style={{ alignItems: 'center' }}>
                                <div style={{ fontWeight: 'bold', fontSize: '14px', color: 'red' }}>You do not have access to this page</div>
                            </Card>
                        }
                    </Grid>
                </Grid>
            </MDBox>
            <Footer />
        </DashboardLayout>
    );
}

export default SupplierPaymentReport;
